import { Box, xcss } from '@atlaskit/primitives';
import { type DatabaseFieldType } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';

import { type ADFDocument } from '@canvas/adf';
import { resolveRichTextValue } from '@canvas/adf/resolve-rich-text-value';
import { CommentRenderer } from '@canvas/editor/comment-renderer';

import { type ViewComponentProps } from './types';

const containerStyles = xcss({
  color: 'color.text',
  minWidth: '0',
});

const disabledContainerStyles = xcss({
  color: 'color.text.disabled',
  minWidth: '0',
});

const RichTextValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.TEXT>
> = ({ value, showDisabledValue }) => {
  const document: ADFDocument = resolveRichTextValue(value);

  return (
    <Box xcss={showDisabledValue ? disabledContainerStyles : containerStyles} as="div">
      <CommentRenderer document={document} alignment="left" />
    </Box>
  );
};

export default RichTextValueView;
